import { SeahorseMenuItem } from '@seahorse/layout';

export const navigation: SeahorseMenuItem[] = [
  {
    route: 'dashboard',
    label: 'layout.sidebar.dashboard',
    icon: 'fa-th-large',
    order: 0,
  },
  {
    route: 'map',
    label: 'layout.sidebar.map',
    icon: 'fa-map-marked-alt',
    permissions: 'map',
    order: 1,
  },
  {
    route: 'nautical/vessels',
    label: 'layout.sidebar.vessels',
    icon: 'fa-ship',
    permissions: 'ships',
    order: 2,
  },
  {
    route: 'nautical/visit',
    label: 'layout.sidebar.visits',
    icon: 'fa-exchange-alt',
    permissions: 'port_visits',
    order: 3,
  },
  {
    route: 'bts-coasting/inbox',
    label: 'BTS',
    permissions: 'bts',
    iconUrl: '../../../../assets/bts-coasting/icons/logo.png',
    order: 4,
  },
  {
    route: 'companies/overview',
    label: 'layout.sidebar.companies',
    icon: 'fa-address-book',
    permissions: 'companies',
    order: 5,
  },
  {
    route: 'custom-ui/cvv/activities',
    label: 'layout.sidebar.activities',
    icon: 'fa-link',
    permissions: 'custom_ui.cvv',
    order: 6,
  },
  {
    route: 'custom-ui/kp/activities',
    label: 'layout.sidebar.activities',
    icon: 'fa-table',
    permissions: 'custom_ui.koperenploeg',
    order: 7,
  },
  {
    route: 'custom-ui/zeehaven-overview',
    label: 'Zeehaven IJmuiden',
    permissions: 'custom_ui.zeehaven_ijmuiden',
    iconUrl: '../../../../assets/images/logos/zeehaven-ijmuiden-square.svg',
    order: 8,
  },
  {
    route: 'custom-ui/beverwijk/overview',
    label: 'Haven Beverwijk',
    permissions: 'custom_ui.haven_beverwijk',
    icon: 'fa-anchor',
    order: 8,
  },
  {
    route: 'invoicing-and-tariffs/invoicing',
    label: 'layout.sidebar.invoicing',
    icon: 'fa-euro-sign',
    permissions: 'invoices',
    order: 9,
    isSecondary: true,
  },
  {
    route: 'cost-calculations',
    label: 'layout.sidebar.costCalculator',
    icon: 'fa-calculator',
    feature: 'portCostCalculation',
    order: 10,
    permissions:
      'cost_calculator.cost_calculator_admin,cost_calculator.cost_calculator_calculate,cost_calculator.cost_calculator_quotes',
    isSecondary: true,
  },
  {
    route: 'reports',
    label: 'layout.sidebar.reports',
    icon: 'fa-chart-line',
    permissions:
      'reports.reports_nautical,reports.reports_financial,user_management.reports',
    order: 11,
    isSecondary: true,
  },
  {
    route: 'tasks/overview',
    label: 'layout.sidebar.tasks',
    icon: 'fa-tasks',
    permissions: 'tasks',
    order: 12,
    isSecondary: true,
  },
  {
    route: 'order-registrations/overview',
    label: 'layout.sidebar.orders',
    icon: 'fa-shopping-cart',
    permissions: 'custom_ui.order_registrations',
    order: 14,
  },
  {
    route: 'storage/home',
    label: 'layout.sidebar.storage',
    icon: 'fa-coins',
    permissions: 'custom_data.custom_data_review',
    order: 15,
    isSecondary: true,
  },
  {
    route: 'admin',
    label: 'layout.sidebar.admin',
    icon: 'fa-cogs',
    permissions:
      'cost_calculator.cost_calculator_admin,custom_data.custom_data_admin,custom_data.inbox_admin,customerportal.customerportal_admin,general.manage_events,general.content_distribution_details,invoices.invoices_configure,invoices.tariff_admin,invoices.tariffs_view,reports_customdata_admin,user_management.reports,user_management.users',
    order: 16,
    isSecondary: true,
  },
];
